/* 孫吳傳・第 3 章：梁東（191 年）
 * 孫堅移屯梁東，被徐榮的大軍三面圍住。營地在中間偏東；西邊的包圍最薄，殺出去後分成兩條路：
 * 往西北是一片墳地（冢間，有燒過的柱子），往西南是一條穿過草叢的間道，通到安全的地方。夜裡，視野很短。 */
export default {
  id: 'liangdong', name: '梁東', W: 8000, H: 5600, seed: 191,
  bases: [[4900, 2800], [7400, 2800]], // 孫堅營、徐榮營
  roads: [
    { pts: [[4900, 2800], [3800, 2850], [2700, 2800], [1800, 2700], [600, 2600]], w: 150 }, // 往西的大路
    { pts: [[2700, 2800], [2300, 2100], [1700, 1300]], w: 90 }, // 往西北的墳地
    { pts: [[2700, 2800], [2200, 3500], [1500, 4200], [800, 4700]], w: 80 }, // 西南的間道
    { pts: [[4900, 2800], [6200, 2800], [7400, 2800]], w: 140 },
  ],
  rocks: [[3300, 1500, 420, 220], [3400, 4200, 460, 220], [5600, 1200, 400, 200], [5800, 4500, 420, 220], [900, 3500, 260, 160], [1000, 1900, 260, 160]],
  woods: 0.5,
  sight: 0.55,
  clearings: [[1700, 1250, 420], [800, 4700, 360], [4900, 2800, 700], [2700, 2800, 300]],
  tents: [{ x: 4900, y: 2800, n: 7, r: 400, col: '#b8433a', flag: '孫' }, { x: 7400, y: 2800, n: 9, r: 460, chief: true, col: '#5a3a30', flag: '徐' }],
  grass: [[1900, 3800, 240, 110], [1300, 4300, 260, 110], [2300, 3300, 200, 100], [1500, 1050, 200, 90], [1950, 1400, 180, 90]],
};
